'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.loadBalancer.details.kubernetes', [
  require('./details.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/loadBalancer/details/details.kubernetes.module.js